import { defineStore } from 'pinia'
import { api } from '@/service/api'
import { Centrifuge } from 'centrifuge'
import type { WebsocketTokenResponse } from '@/interface/websocket/response/tokenResponse'

type Callback = (data: any) => void

export const useWebsocketStore = defineStore('websocketStore', () => {
  const subscribers: Callback[] = []
  let clientCache: Centrifuge | null = null

  const wsProto = document.location.protocol === 'https:' ? 'wss' : 'ws'
  function getClient(): Centrifuge {
    if (clientCache === null) {
      clientCache = new Centrifuge(
        `${wsProto}://${document.location.host}/ws/connection/websocket`,
        { getToken },
      )
    }
    return clientCache
  }

  function subscribe(callback: Callback) {
    subscribers.push(callback)
    return () => {
      const index = subscribers.indexOf(callback)
      if (index >= 0) subscribers.splice(index, 1)
    }
  }

  async function setupClient(userId: number) {
    const client = getClient()

    // Allocate Subscription to a channel.
    const sub = client.newSubscription(`personal:#${userId}`)

    // React on `news` channel real-time publications.
    sub.on('publication', function (ctx) {
      for (const subscriber of subscribers) {
        subscriber(ctx.data)
      }
    })

    // Trigger subscribe process.
    sub.subscribe()

    // Trigger actual connection establishement.
    client.connect()
  }

  async function getToken(): Promise<string> {
    const response: WebsocketTokenResponse = await api.get('/api/private/v1/websocket/token')
    if (!response.token) {
      throw new Error('Failed to get websocket token')
    }
    return response.token
  }

  return {
    subscribe,
    getClient,
    setupClient,
  }
})
